// extracted by mini-css-extract-plugin
module.exports = {"headSection":"appointments__ModalHeader__headSection","dialogTitle":"appointments__ModalHeader__dialogTitle"};